// Public read of admin-managed page SEO overrides, so the client-rendered
// <head> uses the same source of truth as the server-rendered HTML.
import { createServerFn } from "@tanstack/react-start";
import type { PageSeoOverride } from "./page-seo";

export const getPublicSeoOverrides = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ rows: PageSeoOverride[] }> => {
    try {
      const { listSeoOverrides } = await import("./page-seo-store.server");
      return { rows: await listSeoOverrides() };
    } catch {
      return { rows: [] };
    }
  },
);
